<template>
  <div class="SubmittedSlide">
    <SlideHeading v-bind="{ content }" />
    <SlideBodyText v-if="content.body" :blocks="content.body" class="bodyText"/>
  </div>
</template>

<script>
import SlideBodyText from './elems/SlideBodyText.vue'
import SlideHeading from './elems/SlideHeading.vue'

export default {
  components: {
    SlideBodyText,
    SlideHeading,
  },
  props: {
    content: Object,
  },
}
</script>

<style scoped>
.bodyText {
  margin-top: var(--spacing-1);
}
</style>
